import React from 'react';

/** EduGenie brand asset served from CRA public/ */
export const EDUGENIE_AVATAR_SRC = `${process.env.PUBLIC_URL || ''}/ai_genei.png`;

export const EduGenieAvatarImg = ({ className = '', alt = 'EduGenie' }) => (
  <img
    src={EDUGENIE_AVATAR_SRC}
    alt={alt}
    className={className}
    draggable={false}
  />
);
